import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "dark" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton={true}
      richColors={true}
      expand={false}
      position="bottom-right"
      duration={1000} // Even shorter duration (1 second)
      // Improved fixed position to prevent layout shifts with higher z-index
      style={{ 
        position: 'fixed', 
        bottom: '16px', 
        right: '16px',
        zIndex: 10000, // Increased z-index to ensure it's above everything
        maxWidth: '300px', // Limit the width
      }}
      toastOptions={{
        style: {
          position: 'relative', // Ensures the toast doesn't affect document flow
          opacity: 0.85, // Slightly transparent
          fontSize: '13px', // Smaller font
          padding: '6px 10px', // Even less padding
          maxHeight: '70px', // Limit height
          overflow: 'hidden'
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-black/80 group-[.toaster]:backdrop-blur-md group-[.toaster]:text-foreground group-[.toaster]:border-white/10 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "group-[.toast]:bg-transparent group-[.toast]:border-0 group-[.toast]:text-muted-foreground hover:group-[.toast]:text-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
